export default "__VITE_ASSET__E54QFum5__"